import { render, staticRenderFns } from "./emailRegist.vue?vue&type=template&id=f2ce9364&scoped=true"
import script from "./emailRegist.vue?vue&type=script&lang=js"
export * from "./emailRegist.vue?vue&type=script&lang=js"
import style0 from "./emailRegist.vue?vue&type=style&index=0&id=f2ce9364&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ce9364",
  null
  
)

export default component.exports